import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
} from "reactstrap";
import { Link } from 'react-router-dom';
import "../../assets/css/service.css";
import "bootstrap/dist/css/bootstrap.min.css";


export default function Service() {
    const services = [
        {
            title: "Custom Designs",
            description: "Get any design made your way with expedited delivery.",
            icon: "/assets/images/services/img_20251001.jpg",
        },
        {
            title: "Media Support",
            description: "Whether you require images, CADs or renders, we are here to help you.",
            icon: "/assets/images/services/width_201.png",
        },
        {
            title: "Vault Access Service",
            description: "Get Online access to our ready inventory. Delivered in 24 Hours",
            icon: "/assets/images/services/width_200.jpg",
        },
        {
            title: "Market Insights",
            description: "Get Product Level market insights based on location and other factors.",
            icon: "/assets/images/services/img_20251007.jpg",
        },
        {
            title: "Dropshipping Support",
            description: "Upload our styles on your website. Let us do the fulfillment",
            icon: "/assets/images/services/width_205.png",
        },
        {
            title: "Customer Portal",
            description: "Get Access to our customer portal with over 4000 designs.",
            icon: "/assets/images/services/img_20251003.png",
        },
        {
            title: "Bulk Orders",
            description: "With our manufacturing capacity, we can handle large orders with consistent quality",
            icon: "/assets/images/services/width_210.jpg",
        },
    ];

    document.title = "Services";
    return (
        <>
            <section className="services-section">
                <Container className="text-center">
                    <h1 className="service-header mb-2 pb-3 fw-bold text-primary">
                        One Partner For All Your Backend Needs.
                    </h1>

                    <Row className="justify-content-center card-Display">
                        {services.map((service, index) => (
                            <Col key={index} xs="5" sm="5" md="3" lg="3" className="d-flex justify-content-center" style={{ padding: "2px" }}>
                                <div className="service-card">
                                    <img
                                        src={service.icon}
                                        alt={service.title}
                                        className="service-icon"
                                    />
                                    <h3 className="fw-bold">{service.title}</h3>
                                    <p className="description-text">
                                        {service.description}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section className="portal-section">
                <Container className="text-center">
                    <h2 className="fw-bold text-primary portal-title">
                        Purchase Smarter and Faster. One Portal. Many Options.
                    </h2>

                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 d-flex justify-content-center">
                            <div className="pc-video-container position-relative mx-auto">
                                <img
                                    src="/assets/images/home/advantage5.png"
                                    alt="PC Frame"
                                    className="pc-frame img-fluid"
                                />
                                <video
                                    className="pc-screen-video position-absolute"
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                >
                                    <source
                                        src="/assets/videos/Advantages.mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div className="portal-description" data-aos="fade-up">
                        <p>
                            With Our Custom Portal You can get access to 4000+ designs. Make selections and <br></br> connect with our representatives for fast order placing.
                        </p>
                    </div>
                </Container>
            </section>

            <section className="dropshipping-section">
                <Container>
                    <Row
                        className="align-items-center gx-5"
                        style={{ marginTop: "30px" }}
                    >
                        <Col md="6" className="text-center" data-aos="fade-right">
                            <img
                                src="/assets/images/services/dorshipping.jpg"
                                alt="Dropshipping Support"
                                className="img-fluid service-image-Dropshipping"
                            />
                        </Col>

                        <Col md="6" data-aos="fade-left">
                            <div className="fw-bold text-primary service-title-main">
                                Dropshipping Support
                            </div>

                            <div className="service-subtitle text-primary">
                                How it Works
                            </div>

                            <ul className="service-list text-primary">
                                <li>We integrate your platform through an API</li>
                                <li>List our designs on your platform</li>
                                <li>Receive orders</li>
                                <li>We fulfill and ship your order on time</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="custom-design-section py-5">
                <Container>
                    <Row className="align-items-center flex-md-row-reverse">
                        <Col md="6" className="text-center" data-aos="fade-left">
                            <img
                                src="/assets/images/services/Custom.png"
                                alt="Custom Design Support"
                                className="img-fluid service-image"
                            />
                        </Col>

                        <Col
                            md="6"
                            className="custom-support text-center"
                            data-aos="fade-right"
                        >
                            <h2 className="mb-3 fw-bold text-primary">
                                Custom Design Support
                            </h2>

                            <p className="service-description text-primary">
                                Consumers today want what they want and we understand that.
                                At Meera you can send us your customer's dream design and we will bring it to life in no time.
                            </p>

                            <Link
                                to="/contact-us"
                                className="primary-button-cta"
                            >
                                Contact Us
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="service-binstock-section">
                <Container>
                    <Row className="align-items-center">
                        <Col md="6" className="text-center" data-aos="fade-right">
                            <img
                                src="/assets/images/services/vaultaccess.jpg"
                                alt="Vault Access Support"
                                className="img-fluid binstock-image"
                            />
                        </Col>

                        <Col
                            md="6"
                            className="text-center service-section-desc"
                            data-aos="fade-left"
                        >
                            <h2 className="mb-3 fw-bold text-primary">
                                Vault Access Support
                            </h2>

                            <h6 className="text-primary service-subtitile-description">
                                Get Access to ready-to-ship styles. Shipped in 24 hours
                            </h6>

                            <p className="text-primary service-description">
                                You can access our ready to ship inventory directly on our
                                website and place orders to fulfill sensitive merchandise
                                gaps for your store and gain additional sales.
                            </p>

                            <Link
                                to="/vault-access"
                                className="primary-button-cta"
                            >
                                Go To Vault Access
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
